import {Component} from '@angular/core';
import {Store} from '@ngxs/store';
import {PasswordChangeState} from '../../../../state/password-change/password-change.state';
import {SelectSnapshot} from '@ngxs-labs/select-snapshot';
import {PasswordChangeActions} from '../../../../state/password-change/password-change.actions';
import {PasswordPolicy} from '../../../../models/password-policy.model';

@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
})
export class PasswordChangeComponent {
    @SelectSnapshot(PasswordChangeState.modalVisibility) isVisible: boolean;
    @SelectSnapshot(PasswordChangeState.passwordPolicy) passwordPolicy: PasswordPolicy;

    constructor(private store: Store) {
    }

    handleCancel() {
        this.store.dispatch(new PasswordChangeActions.CloseModal());
    }

    onSubmit() {
        this.store.dispatch(new PasswordChangeActions.Submit());
    }

}
